import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useStoreLogin } from "../../store/login";
import WsrvImage from "../utils/WsrvImage";

const Both = dynamic(() => import("../login/Both"), { ssr: false });

import { AiOutlineHome } from "react-icons/ai";
import { FaUnlockAlt } from "react-icons/fa";

const Header = ({ topNav }) => {
  const [openSections, setOpenSections] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = useStoreLogin.getState().user;
  const authToken = useStoreLogin.getState().authToken;
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL;
  const [isClient, setIsClient] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentScreen, setCurrentScreen] = useState(null);
  const client = useStoreLogin.getState().user?.client;
  const DashboardUrl = `${baseUrl}/auth/login/redirect?token=${authToken}&path=student/dashboard&client=${client}`;
  const { logout } = useStoreLogin();
  useEffect(() => {
    setIsClient(true);
  }, []);
  const handleLogout = () => {
    logout();
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => {
      const isOpen = prev[section];
      const newSections = {};

      Object.keys(prev).forEach((key) => {
        newSections[key] = false;
      });

      if (!isOpen) {
        newSections[section] = true;
      }

      return newSections;
    });
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".sidebar") &&
      !event.target.closest(".toggle-bar")
    ) {
      setSidebarOpen(false);
    }
  };

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="relative bg-white w-full md:max-w-lg max-w-sm max-h-[90vh] rounded-2xl flex flex-col shadow-2xl overflow-hidden">
            {/* Header with title and close button */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#EEFBFF]">
              <h2 className="font-bold text-lg text-[#052c24]">
                {currentScreen === "LOGIN" && "Login"}
                {currentScreen === "REGISTER" && "Registration Form"}
                {currentScreen === "FORGOT_PASSWORD" && "Forgot Password"}
              </h2>
              <button
                onClick={() => {
                  setIsOpen(false);
                  setCurrentScreen(null);
                }}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-bold text-sm border border-black shadow-sm transition-colors"
              >
                ✕
              </button>
            </div>
            {/* Scrollable content */}
            <div className="overflow-auto flex-1">
              <Both
                currentScreen={currentScreen}
                setCurrentScreen={setCurrentScreen}
                closeModal={() => {
                  setIsOpen(false);
                  setCurrentScreen(null);
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="container  lg:hidden flex justify-between items-center   lg:pt-0">
        <div className="flex items-center justify-center my-4">
          <Link href="/">
            <WsrvImage
              src={topNav?.website?.logo}
              alt="CLC Logo"
              preset="logo"
              priority
              width={112}
              height={55}
              className="mx-auto w-28 h-auto"
            />
          </Link>
        </div>
        <div>
          <div className="z-20">
            <div className="block lg:hidden toggle-bar" onClick={toggleSidebar}>
              <FaBars className=" bg-white text-[#333333] text-3xl cursor-pointer" />
            </div>
            <div
              className={`fixed top-0 left-0 h-full w-full bg-white pb-20 p-4 transition-all ease-in-out duration-1000 sidebar z-20 ${
                sidebarOpen ? "translate-x-0" : "-translate-x-full"
              }`}
              onClick={(e) => e.stopPropagation()}
              style={{ maxHeight: "100%", overflowY: "auto" }}
            >
              <div className="flex justify-between items-center">
                <WsrvImage
                  src={topNav?.website?.logo}
                  alt="CLC Logo"
                  preset="logo"
                  width={112}
                  height={55}
                  className="w-28 h-auto"
                />
                <button onClick={toggleSidebar} aria-label="Close menu">
                  <ImCross className="" />
                </button>
              </div>

              <ul className="mt-3 text-lg font-bold">
                {topNav?.menus?.PRIMARY_MENU?.items
                  ? topNav.menus.PRIMARY_MENU.items.map((item, index) => (
                      <React.Fragment key={index}>
                        <li className="flex justify-between py-2 border-b border-[#CBCBCB] cursor-pointer relative group">
                          <Link
                            href={item.url}
                            target={item.tab ? "_blank" : ""} rel={item.tab ? "noopener noreferrer" : undefined}
                            className="flex-grow"
                            onClick={toggleSidebar}
                          >
                            {item.title}
                          </Link>
                          {item?.subItems?.length > 0 && (
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSection(item?.title);
                              }}
                            >
                              {openSections[item?.title] ? (
                                <FaMinus />
                              ) : (
                                <FaPlus />
                              )}
                            </span>
                          )}
                        </li>
                        {openSections[item?.title] &&
                          item?.subItems?.length > 0 && (
                            <ul className="pl-4 bg-white transition-all duration-300 ease-in-out translate-y-0 group-hover:traslate-y-100">
                              {item.subItems.map((subItem, subIndex) => (
                                <li
                                  key={subIndex}
                                  className="py-2 flex items-center"
                                >
                                  <Link
                                    href={subItem.url}
                                    target={subItem.tab ? "_blank" : ""} rel={subItem.tab ? "noopener noreferrer" : undefined}
                                    onClick={toggleSidebar}
                                  >
                                    {subItem.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                      </React.Fragment>
                    ))
                  : "subitems list not found"}
              </ul>

              <div>
                {isClient && user && authToken ? (
                  <div className="btn ext-lg font-bold flex flex-col py-1 gap-4">
                    <div className="py-2 border-b border-[#CBCBCB] cursor-pointer">
                      <Link href={DashboardUrl} target="_blank" rel="noopener noreferrer" className=" ">
                        DashBoard
                      </Link>
                    </div>
                    <div className="py-2 border-b border-[#CBCBCB] cursor-pointer ">
                      <button onClick={handleLogout} className="">
                        Logout
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="btn text-lg font-bold  flex flex-col py-1 gap-4">
                    <div className="py-2 border-b border-[#CBCBCB] cursor-pointer block">
                      <button
                        onClick={() => {
                          setCurrentScreen("LOGIN");
                          setIsOpen(true);
                        }}
                        className=""
                      >
                        CLC Login
                      </button>
                    </div>
                    <div className="py-2 border-b border-[#CBCBCB] cursor-pointer ">
                      <button
                        onClick={() => {
                          setCurrentScreen("REGISTER");
                          setIsOpen(true);
                        }}
                        className=""
                      >
                        Signup
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ${
                sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
              }`}
              onClick={handleClickOutside}
            ></div>
          </div>
        </div>
      </div>

      <div className="header lg:block hidden">
        <div className="bg-[#EEFBFF] pt-8 pb-4">
          <div className="container">
            <div className="flex items-center justify-between h-16">
              {/* Logo Section */}
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="flex items-center space-x-3">
                    <Link href="/">
                      <WsrvImage
                        src={topNav?.website?.logo}
                        alt="CLC Logo"
                        preset="logo"
                        priority
                        width={125}
                        height={61}
                        className="w-[125px] h-auto"
                      />
                    </Link>
                  </div>
                </div>
              </div>

              {/* Navigation Menu */}

              {topNav?.menus?.PRIMARY_MENU?.items.length ? (
                <nav className="hidden lg:flex xl:space-x-2 space-x-1">
                  {topNav?.menus?.PRIMARY_MENU?.items.map((item, index) => (
                    <Link
                      key={index}
                      href={item.url}
                      target={item.tab ? "_blank" : ""} rel={item.tab ? "noopener noreferrer" : undefined}
                      className="flex items-center space-x-2 text-[#000000] hover:text-blue-800 px-3 py-2 rounded-md text-lg font-medium transition-colors"
                    >
                      {/* <AiOutlineHome size={18} /> */}
                      {item.img && (
                        <WsrvImage
                          src={item.img}
                          alt=""
                          width={16}
                          height={16}
                          widths={[16, 32]}
                          className="w-4 h-4 object-contain"
                        />
                      )}
                      <span>{item.title}</span>
                    </Link>
                  ))}
                </nav>
              ) : (
                "Nav Itemlist not found"
              )}

              {isClient && user && authToken ? (
                <div className="flex items-center space-x-6">
                  {/* Dashboard Button */}
                  <Link
                    href={DashboardUrl}
                    target="_blank" rel="noopener noreferrer"
                    className="px-5 py-2 rounded-xl bg-[#1C4075] text-white font-medium hover:bg-blue-700 shadow-md transition-all"
                  >
                    Dashboard
                  </Link>

                  {/* Logout Button */}
                  <button
                    onClick={handleLogout}
                    className="px-5 py-2 rounded-xl bg-red-500 text-white font-medium hover:bg-red-600 shadow-md transition-all"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => {
                      setCurrentScreen("LOGIN");
                      setIsOpen(true);
                    }}
                    className="flex items-center space-x-2 text-[#000000] hover:text-blue-800 px-3 py-2 rounded-md text-xl font-medium transition-colors"
                  >
                    <WsrvImage
                      src="https://i.filecdn.in/807clcworld/Loginvector-1756883295141.svg"
                      alt=""
                      width={20}
                      height={20}
                      widths={[20, 40]}
                      className="w-5 h-5"
                    />
                    <span>login</span>
                  </button>

                  <div className=" text-black font-medium text-lg    border-2 border-[#363636] shadow-[5px_5px_0px_#FFD338]">
                    <button
                      onClick={() => {
                        setCurrentScreen("REGISTER");
                        setIsOpen(true);
                      }}
                      className="px-12 py-3  mt-1 ml-1 bg-[#FFD338] "
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              )}

              {/* Mobile Menu Button */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
